// rbacService.js (stub)
// Simple role-check utilities for development. No persistence yet.

import ROLES, { BOOTSTRAP_CAPABLE } from './constants_roles.js';

export function hasRole(user, role) {
    if (!user) return false;
    if (!user.role) return false;
    return user.role === role;
}

export function hasAnyRole(user, roles = []) {
    if (!user || !Array.isArray(roles)) return false;
    const role = String(user.role || user.roleName || user.role_name || '').trim().toLowerCase();
    return roles.some(allowedRole => role === String(allowedRole).trim().toLowerCase());
}

export function isOperationalRole(user) {
    const ops = [
        ROLES.INCIDENT_COMMANDER,
        ROLES.OPERATIONS_CHIEF,
        ROLES.LOGISTICS,
        ROLES.SAFETY,
        ROLES.COMMUNICATIONS,
        ROLES.LIAISON,
    ];
    return user && ops.includes(user.role);
}

export function canBootstrapRuntime(user) {
    if (!user) return false;
    const role = (user.role || user.roleName || user.role_name || '').toLowerCase();
    return BOOTSTRAP_CAPABLE.map(r => r.toLowerCase()).includes(role);
}

export default { hasRole, hasAnyRole, isOperationalRole, canBootstrapRuntime };
